import { render, staticRenderFns } from "./PropertyPinList.vue?vue&type=template&id=89ddfca4&"
import script from "./PropertyPinList.vue?vue&type=script&lang=js&"
export * from "./PropertyPinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports